/* ══════════════════════════════════════════════════════════════
   LASIREN V13 — Moteur du thème
   Panier AJAX (tiroir), quiz « Trouve ton match », modale de
   variantes, barre de livraison gratuite, CTA collant, menu mobile.
   Dépend de window.LaSiren (injecté par layout/theme.liquid).
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var L = window.LaSiren || {};
  var routes = L.routes || {};
  var T = L.strings || {};
  var IS_FR = !!L.isFr || document.documentElement.lang.indexOf('fr') === 0;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ── Route d'accueil sécurisée ───────────────────────────── */
  function fixHomeLinks() {
    var root = routes.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    $$('a[href]').forEach(function (link) {
      var raw = (link.getAttribute('href') || '').trim();
      var title = (link.textContent || '').trim().toLowerCase();
      var isNamedHome = title === 'home' || title === 'accueil';
      var isBrokenHomePath = raw === '/home' || raw === '/pages/home' || /(?:^|\/)pages\/home\/?(?:[?#].*)?$/.test(raw);
      if (isNamedHome || isBrokenHomePath) link.setAttribute('href', root);
    });
  }

  /* ── Argent ──────────────────────────────────────────────── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = L.moneyFormat || '${{amount}}';
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value = '';
    var match = format.match(ph);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(ph, value);
  }
  L.formatMoney = formatMoney;

  /* ── Requêtes panier ─────────────────────────────────────── */
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || T.erreur || 'Request failed');
          err.status = r.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }
  function getCart() {
    return fetch(routes.cart || '/cart.js', { headers: { 'Accept': 'application/json' }, credentials:'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* ── État panier + rendu ─────────────────────────────────── */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-cart-overlay]');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function lineHTML(item) {
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.value); }).join(' · ');
    var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
    return '' +
      '<div class="ls-ligne-panier" data-line-key="' + esc(item.key) + '">' +
        '<a class="img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div>' +
          '<a class="titre" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (opts ? '<div class="variante">' + opts + '</div>' : '') +
          '<div class="p">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="ls-qte">' +
            '<button type="button" data-qte-moins aria-label="' + esc(T.moins || (document.documentElement.lang.indexOf('fr')===0 ? 'Retirer un' : 'Remove one')) + '">−</button>' +
            '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qte-val aria-label="' + esc(T.quantite || 'Quantité') + '">' +
            '<button type="button" data-qte-plus aria-label="' + esc(T.plus || (document.documentElement.lang.indexOf('fr')===0 ? 'Ajouter un' : 'Add one')) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="ls-retirer" data-retirer>' + esc(T.retirer || 'Retirer') + '</button>' +
      '</div>';
  }

  function renderCart(cart) {
    // Compteurs
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    // Barre de livraison gratuite
    updateShip(cart.total_price);
    if (!drawer) return;
    var lines = $('[data-cart-lines]', drawer);
    var footer = $('[data-cart-footer]', drawer);
    var empty = $('[data-cart-empty]', drawer);
    if (cart.item_count === 0) {
      if (lines) lines.innerHTML = '';
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    if (lines) lines.innerHTML = cart.items.map(lineHTML).join('');
    var total = $('[data-cart-total]', drawer);
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function refreshCart() { return getCart().then(renderCart); }

  /* ── Livraison gratuite ──────────────────────────────────── */
  function updateShip(totalCents) {
    var seuil = L.freeShipThreshold || 0;
    $$('[data-ship-bar]').forEach(function (bar) {
      var fill = $('[data-ship-fill]', bar);
      var text = $('[data-ship-text]', bar);
      if (!seuil) { bar.hidden = true; return; }
      var reste = Math.max(0, seuil - totalCents);
      if (fill) fill.style.width = Math.min(100, (totalCents / seuil) * 100) + '%';
      if (text) {
        text.innerHTML = reste === 0
          ? (T.shipOk || 'Livraison gratuite débloquée 🌊')
          : (T.shipReste || 'Plus que {montant} pour la livraison gratuite').replace('{montant}', '<strong>' + formatMoney(reste) + '</strong>');
      }
    });
  }

  /* ── Ouvrir / fermer le tiroir ───────────────────────────── */
  var dernierFocus = null;
  function openDrawer() {
    if (!drawer) return;
    dernierFocus = document.activeElement;
    drawer.classList.add('ouvert');
    drawer.setAttribute('aria-hidden', 'false');
    $$('[data-cart-toggle]').forEach(function (b) { b.setAttribute('aria-expanded','true'); });
    if (overlay) { overlay.classList.add('ouvert'); overlay.setAttribute('aria-hidden','false'); }
    document.body.style.overflow = 'hidden';
    var f = $('[data-cart-close]', drawer); if (f) f.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('ouvert');
    drawer.setAttribute('aria-hidden', 'true');
    $$('[data-cart-toggle]').forEach(function (b) { b.setAttribute('aria-expanded','false'); });
    if (overlay) { overlay.classList.remove('ouvert'); overlay.setAttribute('aria-hidden','true'); }
    document.body.style.overflow = '';
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  /* ── Ajout au panier ─────────────────────────────────────── */
  function addToCart(variantId, quantity, openApres) {
    // If a Siren referral is active, let the Lagoon layer persist/refresh its signed
    // attribution token before the line item is added. A backend outage never blocks shopping.
    var attributionPrep = typeof L.ensureLagoonAttribution === 'function'
      ? Promise.resolve(L.ensureLagoonAttribution()).catch(function () { return null; })
      : Promise.resolve(null);
    return attributionPrep.then(function () {
      return postJSON(routes.cart_add || ((routes.root || '/') + 'cart/add.js'), {
        items: [{ id: String(variantId), quantity: quantity || 1 }]
      });
    }).then(function (res) {
      if (res && res.status && res.status >= 400) {
        throw new Error(res.description || res.message || (T.erreur || 'Erreur'));
      }
      return refreshCart().then(function () { if (openApres !== false) openDrawer(); });
    });
  }

  function changeLine(key, quantity) {
    return postJSON(routes.cart_change || ((routes.root || '/') + 'cart/change.js'), { id: key, quantity: quantity })
      .then(renderCart);
  }
  L.addToCart = addToCart;
  L.refreshCart = refreshCart;
  L.openCart = openDrawer;
  L.closeCart = closeDrawer;

  /* ── Modale de variantes ─────────────────────────────────── */
  var modale = $('[data-modale]');
  var modaleData = null, modaleVariant = null, modalPreviousFocus = null;
  function modalPriceText(data, variant) {
    var cents = variant && variant.price != null ? variant.price : data.price;
    return (data.detail ? data.detail + ' · ' : '') + formatMoney(cents);
  }
  function openModale(data) {
    if (!modale) return;
    modalPreviousFocus = document.activeElement;
    modaleData = data; modaleVariant = null;
    $('[data-m-nom]', modale).textContent = data.title;
    $('[data-m-sous]', modale).textContent = modalPriceText(data, null);
    $('[data-m-erreur]', modale).textContent = '';
    var finalEl = $('[data-m-final]', modale);
    if (finalEl) finalEl.textContent = data.final ? (T.venteFinale || 'Final sale — hygiene item. Check your measurements before ordering.') : '';
    var lab = $('[data-m-lab]', modale);
    if (lab) lab.textContent = data.optionName || (T.choisir || 'Choose an option');
    $('[data-m-options]', modale).innerHTML = data.variants.map(function (v) {
      return '<button class="ls-opt" type="button" data-variant="' + esc(v.id) + '"' +
        (v.available ? '' : ' disabled') + ' aria-pressed="false">' + esc(v.title) + '</button>';
    }).join('');
    modale.classList.add('ouvert');
    modale.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = $('.ls-opt:not([disabled])', modale) || $('[data-m-annuler]', modale);
    if (first) first.focus(); else modale.focus();
  }
  function closeModale() {
    if (!modale || !modale.classList.contains('ouvert')) return;
    modale.classList.remove('ouvert');
    modale.setAttribute('aria-hidden', 'true');
    modaleData = null;
    modaleVariant = null;
    var drawerOpen = drawer && drawer.classList.contains('ouvert');
    if (!drawerOpen) document.body.style.overflow = '';
    if (!drawerOpen && modalPreviousFocus && modalPreviousFocus.focus) modalPreviousFocus.focus();
    modalPreviousFocus = null;
  }

  /* ── Carte produit (rendu JS, utilisé par le quiz) ───────── */
  function cardHTML(p, avecPourquoi) {
    var variants = Array.isArray(p.variants) ? p.variants : [];
    var availableVariants = variants.filter(function (v) { return v.available; });
    var selected = availableVariants[0] || variants[0] || null;
    var directVariants = variants.length > 1 && variants.length <= 8;
    var aVariantes = variants.length > 1;
    var basePrice = selected && selected.price != null ? selected.price : p.price;
    var baseCompare = selected && selected.compare_at_price != null ? selected.compare_at_price : p.compare_at_price;
    var prix = baseCompare && baseCompare > basePrice
      ? '<span class="barre">' + formatMoney(baseCompare) + '</span><span class="solde">' + formatMoney(basePrice) + '</span>'
      : formatMoney(basePrice);
    var img = p.image
      ? '<img class="ls-card-image ls-card-image-primary" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' +
        (p.image2 ? '<img class="ls-card-image ls-card-image-hover" src="' + esc(p.image2) + '" alt="" aria-hidden="true" loading="lazy">' : '')
      : '<div class="placeholder">LaSirèn</div>';
    var discount = p.compare_at_price && p.compare_at_price > p.price
      ? Math.round((1 - (p.price / p.compare_at_price)) * 100)
      : 0;
    var quickLabel = directVariants || !aVariantes
      ? (IS_FR ? 'Ajout rapide' : 'Quick Add')
      : esc(T.choisirOption || (IS_FR ? 'Choisir l’option' : 'Choose option'));
    var mobileLabel = directVariants || !aVariantes
      ? (IS_FR ? 'Ajouter au sac' : 'Add to bag')
      : esc(T.choisirOption || (IS_FR ? 'Choisir l’option' : 'Choose option'));
    var quick = !p.available ? '' : '<button class="ls-card-quick-add" type="button" data-add-card><span aria-hidden="true">＋</span>' + quickLabel + '</button>';
    var btn = !p.available
      ? '<button class="ls-commander ls-card-mobile-add" disabled>' + esc(T.epuise || (IS_FR ? 'Épuisé' : 'Sold out')) + '</button>'
      : '<button class="ls-commander ls-card-mobile-add" type="button" data-add-card>' + mobileLabel + '</button>';
    var pills = '';
    if (p.available && directVariants) {
      pills = '<div class="ls-card-variants" data-card-variants>' +
        '<p>' + esc(p.optionName || (IS_FR ? 'Option' : 'Option')) + '</p>' +
        '<div class="ls-card-variant-list">' + variants.map(function (v) {
          var pressed = selected && String(selected.id) === String(v.id);
          return '<button type="button" class="ls-card-variant" data-card-variant="' + esc(v.id) + '" aria-pressed="' + (pressed ? 'true' : 'false') + '"' +
            (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
        }).join('') + '</div></div>';
    }
    return '' +
      '<article class="ls-produit ls-produit--lovable" data-card data-selected-variant="' + (selected ? esc(selected.id) : '') + '" data-direct-variants="' + (directVariants ? 'true' : 'false') + '">' +
        '<script type="application/json" data-card-json>' + JSON.stringify(p).replace(/</g, '\\u003c') + '</' + 'script>' +
        '<div class="ls-visuel">' +
          '<a class="ls-card-media-link" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' + img + '</a>' +
          '<div class="ls-card-badges">' +
            (p.epingle ? '<span class="ls-epingle ls-epingle--lovable">' + esc(p.epingle) + '</span>' : '') +
            (discount ? '<span class="ls-card-discount">−' + discount + '%</span>' : '') +
          '</div>' +
          (p.stock ? '<span class="ls-stock">' + esc(p.stock) + '</span>' : '') +
          (!p.available ? '<span class="ls-epuise">' + esc(T.epuise || (IS_FR ? 'Épuisé' : 'Sold out')) + '</span>' : '') +
          quick +
        '</div>' +
        '<div class="ls-card-body">' +
          '<div class="ls-ligne"><span class="ls-nom"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></span><span class="ls-prix" data-card-price>' + prix + '</span></div>' +
          (p.detail ? '<span class="ls-detail">' + esc(p.detail) + '</span>' : '') +
          (avecPourquoi && p.pourquoi ? '<span class="ls-pourquoi">' + esc(p.pourquoi) + '</span>' : '') +
          pills + btn +
        '</div>' +
      '</article>';
  }

  function cardData(el) {
    var card = el.closest('[data-card]');
    if (!card) return null;
    var json = $('[data-card-json]', card);
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch (e) { return null; }
  }

  /* ── Motion Lovable : X/Y + 3D tilt + glare curseur ──────── */
  function initProductCardMotion(scope) {
    var racine = scope || document;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.ls-produit', racine).forEach(function (card) {
      if (card.dataset.motionReady === 'true') return;
      card.dataset.motionReady = 'true';
      if (coarse || reduced) return;
      var frame = null;
      var lastEvent = null;
      function applyMove() {
        frame = null;
        if (!lastEvent) return;
        var rect = card.getBoundingClientRect();
        var px = rect.width ? (lastEvent.clientX - rect.left) / rect.width : 0.5;
        var py = rect.height ? (lastEvent.clientY - rect.top) / rect.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        /* Exact Lovable Tilt3D geometry: max=9deg, no flat X/Y slide. */
        var rotateY = (px - 0.5) * 18;
        var rotateX = (0.5 - py) * 18;
        card.style.setProperty('--card-shift-x', '0px');
        card.style.setProperty('--card-shift-y', '0px');
        card.style.setProperty('--card-rotate-y', rotateY.toFixed(2) + 'deg');
        card.style.setProperty('--card-rotate-x', rotateX.toFixed(2) + 'deg');
        card.style.setProperty('--card-glow-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--card-glow-y', (py * 100).toFixed(1) + '%');
        card.style.setProperty('--card-glow-o', '.52');
      }
      card.addEventListener('pointerenter', function () {
        card.classList.add('is-hovering');
      });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        lastEvent = e;
        if (!frame) frame = requestAnimationFrame(applyMove);
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        lastEvent = null;
        card.classList.remove('is-hovering');
        card.style.setProperty('--card-shift-x', '0px');
        card.style.setProperty('--card-shift-y', '0px');
        card.style.setProperty('--card-rotate-y', '0deg');
        card.style.setProperty('--card-rotate-x', '0deg');
        card.style.setProperty('--card-glow-x', '50%');
        card.style.setProperty('--card-glow-y', '50%');
        card.style.setProperty('--card-glow-o', '0');
      });
    });
  }

  /* ── Quiz option cards — Lovable Tilt3D + aqua pedestal ──── */
  function initQuizOptionMotion(scope) {
    var racine = scope || document;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.ls-q-opt', racine).forEach(function (card) {
      if (card.dataset.quizTiltReady === 'true') return;
      card.dataset.quizTiltReady = 'true';
      if (coarse || reduced) return;

      var frame = null;
      var lastEvent = null;
      var max = 8;
      var lift = 11;

      function applyMove() {
        frame = null;
        if (!lastEvent) return;
        var r = card.getBoundingClientRect();
        var px = r.width ? (lastEvent.clientX - r.left) / r.width : 0.5;
        var py = r.height ? (lastEvent.clientY - r.top) / r.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        var rotateX = (0.5 - py) * max * 2;
        var rotateY = (px - 0.5) * max * 2;
        card.style.transform = 'perspective(1050px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) translateZ(' + lift + 'px) scale(1.015)';
        card.style.setProperty('--quiz-glare-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--quiz-glare-y', (py * 100).toFixed(1) + '%');
        card.style.setProperty('--quiz-glare-o', '.54');
      }

      card.addEventListener('pointerenter', function () {
        card.classList.add('is-tilting');
      });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        lastEvent = e;
        if (!frame) frame = requestAnimationFrame(applyMove);
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        lastEvent = null;
        card.classList.remove('is-tilting');
        card.style.transform = 'perspective(1050px) rotateX(0deg) rotateY(0deg) translateZ(0) scale(1)';
        card.style.setProperty('--quiz-glare-x', '50%');
        card.style.setProperty('--quiz-glare-y', '50%');
        card.style.setProperty('--quiz-glare-o', '0');
      });
    });
  }

  /* ── Quiz « Trouve ton match » ───────────────────────────── */
  var TONS = [
    { id:'nacre', nom:'Nacre', hex:'#F2E1CB', famille:IS_FR?'Rosé pâle, argent, glacé':'Pale rose, silver, icy', texte:'', swatches:['#F2E1CB','#E6C9C9','#D9D2E0','#C7D6DE'] },
    { id:'sable', nom:IS_FR?'Sable':'Sand', hex:'#E8C39E', famille:IS_FR?'Rosé et tons chair froids':'Rose and cool skin tones', texte:'', swatches:['#E8C39E','#D9A9A0','#C7B8C9','#B7C9D1'] },
    { id:'miel', nom:IS_FR?'Miel':'Honey', hex:'#D2A06A', famille:IS_FR?'Pêche, corail, or':'Peach, coral, gold', texte:'', swatches:['#D2A06A','#E8A87C','#F2B33D','#C97B5A'] },
    { id:'caramel', nom:'Caramel', hex:'#B07845', famille:IS_FR?'Terracotta, bronze, chrome':'Terracotta, bronze, chrome', texte:'', swatches:['#B07845','#A85A3C','#C9A25C','#8FA9B0'] },
    { id:'cacao', nom:'Cacao', hex:'#7A4A2B', famille:IS_FR?'Turquoise, prune, or':'Turquoise, plum, gold', texte:'', swatches:['#7A4A2B','#1A7A78','#6B3B6B','#E8B84A'] },
    { id:'ebene', nom:IS_FR?'Ébène':'Ebony', hex:'#4A2C1A', famille:IS_FR?'Blanc, néon, chrome':'White, neon, chrome', texte:'', swatches:['#4A2C1A','#F7F2E9','#7FE8E2','#9BB0B8'] },
    { id:'onyx', nom:'Onyx', hex:'#301A10', famille:IS_FR?'Or, tons précieux, blanc':'Gold, jewel tones, white', texte:'', swatches:['#301A10','#E8B84A','#1F7A5A','#F7F2E9'] },
    { id:'obsidienne', nom:IS_FR?'Obsidienne':'Obsidian', hex:'#1C0F09', famille:IS_FR?'Fuchsia, cobalt, or liquide':'Fuchsia, cobalt, liquid gold', texte:'', swatches:['#1C0F09','#D6247E','#2B6DE0','#E8B84A'] },
    { id:'jais', nom:IS_FR?'Jais':'Jet', hex:'#130A07', famille:IS_FR?'Néon, blanc pur, chrome':'Neon, pure white, chrome', texte:'', swatches:['#130A07','#F7F2E9','#FF3FA4','#7FE8E2'] }
  ];
  var VIBES = [
    { id:'naturel', nom:IS_FR?'Discret':'Effortless', sous:IS_FR?'Ça se remarque pas, ça se ressent':'Quiet impact, polished presence' },
    { id:'glam', nom:IS_FR?'Glamour':'Glam', sous:IS_FR?'Prête pour la photo':'Camera-ready polish' },
    { id:'audacieux', nom:IS_FR?'Audacieux':'Bold', sous:IS_FR?'On me voit arriver':'A look that leads the room' }
  ];
  L.tons = TONS;
  L.vibes = VIBES;

  function initQuiz() {
    var quiz = $('[data-quiz]');
    if (!quiz) return;
    var produits = (L.quizProducts || []);
    var rayons = (L.quizRayons || []);
    var STORAGE_KEY = 'lasiren_quiz_match_v2';
    var VIBES_QUIZ = [
      { id:'naturel', nom:IS_FR?'Naturel':'Effortless', sous:IS_FR?'Facile à porter, toujours soigné':'Easy to wear, always polished' },
      { id:'glam', nom:IS_FR?'Glamour':'Glam', sous:IS_FR?'Plus travaillé, prêt pour la photo':'More polished, camera-ready' },
      { id:'audacieux', nom:IS_FR?'Audacieux':'Bold', sous:IS_FR?'Une pièce qui mène le look':'One piece that leads the Look' }
    ];
    var TONS_QUIZ = TONS.map(function (t) {
      return { id:t.id, nom:t.nom, sous:t.famille, hex:t.hex };
    }).concat([{ id:'tous', nom:IS_FR?'Je choisis surtout le style':'Style matters most to me', sous:IS_FR?'Pas de préférence de ton':'No tone preference', hex:'linear-gradient(135deg,#77ded8,#d9bc73,#c8b5e8)' }]);
    var QUESTIONS = [
      { q:IS_FR?'Qu’as-tu envie de révéler aujourd’hui?':'What are you shopping for today?', aide:IS_FR?'Choisis l’univers qui te fait le plus vibrer.':'Choose the LaSirèn world calling you most right now.', cle:'rayon', choix:rayons.map(function(r){return {v:r.id,lab:r.titre,sub:r.sous};}) },
      { q:IS_FR?'Quelle énergie veux-tu faire sentir?':'Which energy do you want to make them feel?', aide:IS_FR?'On affine la sélection selon ton aura du moment.':'We’ll shape the edit around the aura you want to wear.', cle:'vibe', choix:VIBES_QUIZ.map(function(v){return {v:v.id,lab:v.nom,sub:v.sous};}) },
      { q:IS_FR?'Quelles nuances te rendent irrésistible?':'Which tones make you feel irresistible?', aide:IS_FR?'Ça nous aide à choisir les couleurs et finis qui illuminent ton look.':'This helps us choose the shades and finishes that light up your look.', cle:'ton', choix:TONS_QUIZ.map(function(t){return {v:t.id,lab:t.nom,sub:t.sous,color:t.hex};}) }
    ].filter(function (Q) { return Q.choix.length; });

    var jeu = $('[data-q-jeu]', quiz);
    var result = $('[data-q-result]', quiz);
    var tagsInput = $('[data-q-tags]', quiz);
    var etape = 0;
    var rep = {};

    function rendreQuestion() {
      var Q = QUESTIONS[etape];
      $('[data-q-question]', quiz).textContent = Q.q;
      $('[data-q-aide]', quiz).textContent = Q.aide;
      $('[data-q-choix]', quiz).innerHTML = Q.choix.map(function (c) {
        var swatch = c.color ? '<span class="ls-q-swatch" style="background:' + esc(c.color) + '" aria-hidden="true"></span>' : '';
        return '<button class="ls-q-opt" type="button" data-v="' + esc(c.v) + '">' + swatch +
          '<span class="lab">' + esc(c.lab) + (c.sub ? '<span class="sub">' + esc(c.sub) + '</span>' : '') + '</span>' +
        '</button>';
      }).join('');
      initQuizOptionMotion($('[data-q-choix]', quiz) || quiz);
      $$('[data-q-etape] .ls-pt', quiz).forEach(function (p, i) { p.classList.toggle('on', i <= etape); });
      var retour = $('[data-q-retour]', quiz); if (retour) retour.hidden = etape === 0;
    }

    function hasTon(p, ton) {
      return ton && ton !== 'tous' && Array.isArray(p.tons) && p.tons.indexOf(ton) > -1;
    }

    function hasVibe(p, vibe) {
      if (!vibe) return false;
      if (Array.isArray(p.vibes) && p.vibes.indexOf(vibe) > -1) return true;
      return p.vibe === vibe;
    }

    function score(p) {
      var s = 0;
      if (p.rayon === rep.rayon) s += 100;
      if (hasVibe(p, rep.vibe)) s += 28;
      if (hasTon(p, rep.ton)) s += 20;
      if (Array.isArray(p.looks) && p.looks.length) s += 2;
      if ((!p.vibes || !p.vibes.length) && !p.vibe) s += 1;
      return s;
    }

    function enrichMatch(p, vibe, ton) {
      var copy = Object.assign({}, p);
      var raisons = [];
      if (hasVibe(p, rep.vibe) && vibe) raisons.push(vibe.nom.toLowerCase());
      if (hasTon(p, rep.ton) && ton) raisons.push((IS_FR ? 'ton ' : 'tone ') + ton.nom.toLowerCase());
      copy.pourquoi = raisons.length ? (IS_FR ? 'Choisi pour ton style ' : 'Picked for your style ') + raisons.join(' · ') : (IS_FR ? 'Sélectionné dans ton univers LaSirèn' : 'Selected from your LaSirèn category');
      return copy;
    }

    function syncCrmTags() {
      if (!tagsInput) return;
      var tags = ['prospect', 'quiz'];
      if (rep.rayon) tags.push('quiz-' + rep.rayon);
      if (rep.vibe) tags.push('vibe-' + rep.vibe);
      if (rep.ton && rep.ton !== 'tous') tags.push('ton-' + rep.ton);
      tagsInput.value = tags.join(',');
    }

    function calculer(skipSave) {
      var rayon = rayons.filter(function (r) { return r.id === rep.rayon; })[0];
      var vibe = VIBES_QUIZ.filter(function (v) { return v.id === rep.vibe; })[0];
      var ton = TONS_QUIZ.filter(function (t) { return t.id === rep.ton; })[0];
      $('[data-q-fam-nom]', quiz).textContent = rayon ? rayon.titre : 'LaSirèn';
      $('[data-q-fam-texte]', quiz).textContent = [
        vibe ? vibe.nom : '',
        ton && ton.id !== 'tous' ? ton.nom : '',
        rayon ? rayon.sous : ''
      ].filter(Boolean).join(' · ');

      var top = produits.slice().filter(function (p) {
        return p.available !== false && (!rep.rayon || p.rayon === rep.rayon);
      }).sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);

      if (!top.length) {
        top = produits.slice().filter(function (p) { return p.available !== false; })
          .sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);
      }

      var cible = $('[data-q-produits]', quiz);
      if (top.length) {
        cible.innerHTML = top.map(function (p) { return cardHTML(enrichMatch(p, vibe, ton), true); }).join('');
      } else {
        cible.innerHTML = '<p class="ls-q-vide">' + (IS_FR ? 'On prépare encore cette sélection. Explore ton univers pendant qu’on complète le catalogue.' : 'We’re still building this edit. Explore LaSirèn while the catalog grows.') + '</p>';
      }

      initProductCardMotion(cible || quiz);
      initInteractiveGlow(cible || quiz);
      syncCrmTags();
      if (!skipSave) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(rep)); } catch (e) {}
      }
      if (jeu) jeu.style.display = 'none';
      if (result) result.classList.add('on');
    }

    function recommencer() {
      etape = 0; rep = {};
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      if (result) result.classList.remove('on');
      if (jeu) jeu.style.display = '';
      rendreQuestion();
    }

    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-v]');
      if (opt && quiz.contains(opt)) {
        rep[QUESTIONS[etape].cle] = opt.dataset.v;
        if (etape < QUESTIONS.length - 1) { etape++; rendreQuestion(); } else calculer(false);
        return;
      }
      if (e.target.closest('[data-q-retour]')) { if (etape > 0) { etape--; rendreQuestion(); } return; }
      if (e.target.closest('[data-q-recommencer]')) { recommencer(); return; }
    });

    var restored = false;
    if (window.location.hash === '#quiz') {
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (saved && saved.rayon && saved.vibe && saved.ton) {
          rep = saved;
          calculer(true);
          restored = true;
        }
      } catch (e) {}
    }
    if (!restored) rendreQuestion();
  }

  /* ── Délégation de clics globale ─────────────────────────── */
  document.addEventListener('click', function (e) {
    // Ouvrir panier
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); refreshCart().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    if (overlay && e.target === overlay) { closeDrawer(); return; }

    // Choisir une variante directement sur la carte (Lovable fusion)
    var cardVariant = e.target.closest('[data-card-variant]');
    if (cardVariant && !cardVariant.disabled) {
      e.preventDefault();
      var productCard = cardVariant.closest('[data-card]');
      if (!productCard) return;
      $$('.ls-card-variant', productCard).forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
      cardVariant.setAttribute('aria-pressed', 'true');
      productCard.setAttribute('data-selected-variant', cardVariant.getAttribute('data-card-variant') || '');
      var selectedData = cardData(cardVariant);
      if (selectedData && Array.isArray(selectedData.variants)) {
        var chosen = selectedData.variants.find(function (v) { return String(v.id) === String(cardVariant.getAttribute('data-card-variant')); });
        var priceEl = $('[data-card-price]', productCard);
        if (chosen && priceEl) {
          if (chosen.compare_at_price && chosen.compare_at_price > chosen.price) {
            priceEl.innerHTML = '<span class="barre">' + formatMoney(chosen.compare_at_price) + '</span><span class="solde">' + formatMoney(chosen.price) + '</span>';
          } else {
            priceEl.textContent = formatMoney(chosen.price);
          }
        }
      }
      return;
    }

    // Ajouter depuis une carte
    var addCard = e.target.closest('[data-add-card]');
    if (addCard) {
      e.preventDefault();
      var data = cardData(addCard);
      if (!data) return;
      var productCard = addCard.closest('[data-card]');
      var selectedId = productCard ? productCard.getAttribute('data-selected-variant') : '';
      var direct = productCard && productCard.getAttribute('data-direct-variants') === 'true';
      if (selectedId && (direct || !data.variants || data.variants.length <= 1)) {
        addCard.disabled = true;
        addToCart(selectedId, 1).catch(function (err) { alert(err.message || (T.erreur || 'Erreur')); })
          .then(function () { addCard.disabled = false; });
        return;
      }
      if (data.variants && data.variants.length > 1) { openModale(data); return; }
      var vid = data.variants && data.variants[0] ? data.variants[0].id : data.id;
      addCard.disabled = true;
      addToCart(vid, 1).catch(function (err) { alert(err.message || (T.erreur || 'Erreur')); })
        .then(function () { addCard.disabled = false; });
      return;
    }

    // Choix dans la modale
    var opt = e.target.closest('.ls-opt');
    if (opt && modale && modale.contains(opt) && !opt.disabled) {
      $$('.ls-opt', modale).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      opt.setAttribute('aria-pressed', 'true');
      modaleVariant = opt.dataset.variant;
      $('[data-m-erreur]', modale).textContent = '';
      if (modaleData && Array.isArray(modaleData.variants)) {
        var selectedVariant = modaleData.variants.find(function (v) { return String(v.id) === String(modaleVariant); });
        if (selectedVariant) $('[data-m-sous]', modale).textContent = modalPriceText(modaleData, selectedVariant);
      }
      return;
    }
    if (e.target.closest('[data-m-annuler]')) { closeModale(); return; }
    if (modale && e.target === modale) { closeModale(); return; }
    var payer = e.target.closest('[data-m-payer]');
    if (payer) {
      if (!modaleVariant) { $('[data-m-erreur]', modale).textContent = T.choisisOption || 'Choisis une option avant de continuer.'; return; }
      payer.disabled = true;
      addToCart(modaleVariant, 1).then(function () { closeModale(); })
        .catch(function (err) { $('[data-m-erreur]', modale).textContent = err.message || (T.erreur || 'Erreur'); })
        .then(function () { payer.disabled = false; });
      return;
    }

    // Quantités dans le tiroir
    var ligne = e.target.closest('[data-line-key]');
    if (ligne) {
      var key = ligne.dataset.lineKey;
      var input = $('[data-qte-val]', ligne);
      var q = parseInt(input ? input.value : '1', 10) || 1;
      if (e.target.closest('[data-qte-plus]')) { changeLine(key, q + 1); return; }
      if (e.target.closest('[data-qte-moins]')) { changeLine(key, Math.max(0, q - 1)); return; }
      if (e.target.closest('[data-retirer]')) { changeLine(key, 0); return; }
    }
  });

  function trapFocus(e, container) {
    if (e.key !== 'Tab' || !container) return;
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null; });
    if (!focusables.length) { e.preventDefault(); container.focus && container.focus(); return; }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModale(); closeDrawer(); if (menuMobile && menuMobile.classList.contains('ouvert')) { menuMobile.classList.remove('ouvert'); menuMobile.setAttribute('aria-hidden','true'); if (burger) { burger.setAttribute('aria-expanded','false'); burger.focus(); } } return; }
    if (modale && modale.classList.contains('ouvert')) { trapFocus(e, modale); return; }
    if (drawer && drawer.classList.contains('ouvert')) trapFocus(e, drawer);
  });

  // Saisie directe de quantité
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qte-val]');
    if (input) {
      var ligne = input.closest('[data-line-key]');
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      if (ligne) changeLine(ligne.dataset.lineKey, q);
    }
  });

  /* ── Formulaire produit (page produit) ───────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isProductForm = form.hasAttribute('data-product-form') || action.indexOf('/cart/add') > -1;
    if (!isProductForm) return;
    e.preventDefault();
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    if (!idInput || !idInput.value) return;
    var btn = $('[data-add-btn]', form);
    if (btn) btn.disabled = true;
    addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1)
      .catch(function (err) { alert(err.message || (T.erreur || 'Erreur')); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ── CTA collant mobile : apparaît quand le vrai ATC sort de l’écran ─ */
  function initStickyCTA() {
    var sticky = $('[data-sticky-cta]');
    if (!sticky) return;
    var source = $('[data-sticky-source]');
    var seuilScroll = parseInt(sticky.dataset.stickyCta || '420', 10);

    function fallback() {
      sticky.classList.toggle('on', window.scrollY > seuilScroll);
    }

    if ('IntersectionObserver' in window && source) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('on', !entry.isIntersecting && window.scrollY > 120);
      }, { threshold: 0.08 });
      observer.observe(source);
    } else {
      window.addEventListener('scroll', fallback, { passive: true });
      fallback();
    }
  }

  /* ── Menu mobile ─────────────────────────────────────────── */
  var burger = $('[data-burger]');
  var menuMobile = $('[data-menu-mobile]');
  if (burger && menuMobile) {
    var menuClose = $('[data-menu-close]', menuMobile);
    function setMobileMenu(open, restoreFocus) {
      menuMobile.classList.toggle('ouvert', !!open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuMobile.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        var firstLink = $('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', menuMobile);
        if (firstLink) firstLink.focus();
      } else if (restoreFocus && burger.focus) {
        burger.focus();
      }
    }
    setMobileMenu(false, false);
    burger.addEventListener('click', function () {
      setMobileMenu(!menuMobile.classList.contains('ouvert'), false);
    });
    if (menuClose) {
      menuClose.addEventListener('click', function () { setMobileMenu(false, true); });
    }
    menuMobile.addEventListener('click', function (event) {
      if (event.target.closest('a')) setMobileMenu(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuMobile.classList.contains('ouvert')) setMobileMenu(false, true);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1100 && menuMobile.classList.contains('ouvert')) setMobileMenu(false, false);
    }, { passive:true });
  }

  /* ── Init ────────────────────────────────────────────────── */

  /* ── Lovable Tilt3D for Shop by Universe ────────────────────
     Ported from the Lovable CategoryShowcase/Tilt3D behavior:
     perspective(1100px), max 7deg, 10px lift, glossy cursor glare.
  */
  function initUniverseTilt(scope) {
    var racine = scope || document;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.ls-v5-universe', racine).forEach(function (card) {
      if (card.dataset.universeTiltReady === 'true') return;
      card.dataset.universeTiltReady = 'true';
      if (coarse || reduced) return;

      var frame = null;
      var lastEvent = null;
      var max = 7;
      var lift = 10;

      function applyMove() {
        frame = null;
        if (!lastEvent) return;
        var r = card.getBoundingClientRect();
        var px = r.width ? (lastEvent.clientX - r.left) / r.width : 0.5;
        var py = r.height ? (lastEvent.clientY - r.top) / r.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        var rotateX = (0.5 - py) * max * 2;
        var rotateY = (px - 0.5) * max * 2;
        card.style.transform = 'perspective(1100px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) translateZ(' + lift + 'px) scale(1.012)';
        card.style.setProperty('--universe-glare-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--universe-glare-y', (py * 100).toFixed(1) + '%');
        card.style.setProperty('--universe-glare-o', '.50');
      }

      card.addEventListener('pointerenter', function () {
        card.classList.add('is-tilting');
      });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        lastEvent = e;
        if (!frame) frame = requestAnimationFrame(applyMove);
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        lastEvent = null;
        card.classList.remove('is-tilting');
        card.style.transform = 'perspective(1100px) rotateX(0deg) rotateY(0deg) translateZ(0) scale(1)';
        card.style.setProperty('--universe-glare-x', '50%');
        card.style.setProperty('--universe-glare-y', '50%');
        card.style.setProperty('--universe-glare-o', '0');
      });
    });
  }



  /* ── Shoppable Looks — Lovable Tilt3D + aqua pedestal ─────── */
  function initLookTilt(scope) {
    var racine = scope || document;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.ls-v5-look', racine).forEach(function (card) {
      if (card.dataset.lookTiltReady === 'true') return;
      card.dataset.lookTiltReady = 'true';
      if (coarse || reduced) return;

      var frame = null;
      var lastEvent = null;
      var max = 6.5;
      var lift = 11;

      function applyMove() {
        frame = null;
        if (!lastEvent) return;
        var r = card.getBoundingClientRect();
        var px = r.width ? (lastEvent.clientX - r.left) / r.width : 0.5;
        var py = r.height ? (lastEvent.clientY - r.top) / r.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        var rotateX = (0.5 - py) * max * 2;
        var rotateY = (px - 0.5) * max * 2;
        card.style.transform = 'perspective(1150px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) translateZ(' + lift + 'px) scale(1.008)';
        card.style.setProperty('--look-glare-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--look-glare-y', (py * 100).toFixed(1) + '%');
        card.style.setProperty('--look-glare-o', '.52');
      }

      card.addEventListener('pointerenter', function () { card.classList.add('is-tilting'); });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        lastEvent = e;
        if (!frame) frame = requestAnimationFrame(applyMove);
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        lastEvent = null;
        card.classList.remove('is-tilting');
        card.style.transform = 'perspective(1150px) rotateX(0deg) rotateY(0deg) translateZ(0) scale(1)';
        card.style.setProperty('--look-glare-x', '50%');
        card.style.setProperty('--look-glare-y', '50%');
        card.style.setProperty('--look-glare-o', '0');
      });
    });
  }

  /* ── Key controls — restrained cursor tilt + moving light ─── */
  function initInteractiveGlow(scope) {
    var racine = scope || document;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var selector = '.lsv6-btn,.ls-bouton,.ls-filtre,.ls-v5-look-cta,.lsv6-cart,.lsv6-menu-btn,.lsv6-mobile-close,.ls-card-quick-add,.ls-card-mobile-add,.lsv6-pills a';
    $$(selector, racine).forEach(function (el) {
      if (el.dataset.uiTiltReady === 'true') return;
      el.dataset.uiTiltReady = 'true';
      if (reduced) return;
      var max = 2.8;
      if (coarse) {
        var onTouchStart = function () {
          el.classList.add('is-ui-tilting');
          el.style.setProperty('--ui-glow-x', '50%');
          el.style.setProperty('--ui-glow-y', '50%');
          el.style.setProperty('--ui-glow-o', '.74');
          el.style.setProperty('--ui-rotate-x', '-1.2deg');
          el.style.setProperty('--ui-rotate-y', '1.2deg');
        };
        var onTouchEnd = function () {
          setTimeout(function () {
            el.classList.remove('is-ui-tilting');
            el.style.setProperty('--ui-glow-x', '50%');
            el.style.setProperty('--ui-glow-y', '50%');
            el.style.setProperty('--ui-glow-o', '0');
            el.style.setProperty('--ui-rotate-x', '0deg');
            el.style.setProperty('--ui-rotate-y', '0deg');
          }, 150);
        };
        el.addEventListener('pointerdown', onTouchStart);
        el.addEventListener('pointerup', onTouchEnd);
        el.addEventListener('pointercancel', onTouchEnd);
        el.addEventListener('pointerleave', onTouchEnd);
        return;
      }
      el.addEventListener('pointerenter', function () {
        el.classList.add('is-ui-tilting');
        el.style.setProperty('--ui-glow-o', '.68');
      });
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        var r = el.getBoundingClientRect();
        var px = r.width ? (e.clientX - r.left) / r.width : 0.5;
        var py = r.height ? (e.clientY - r.top) / r.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        el.style.setProperty('--ui-glow-x', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--ui-glow-y', (py * 100).toFixed(1) + '%');
        el.style.setProperty('--ui-rotate-x', ((0.5 - py) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--ui-rotate-y', ((px - 0.5) * max * 2).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-ui-tilting');
        el.style.setProperty('--ui-glow-x', '50%');
        el.style.setProperty('--ui-glow-y', '50%');
        el.style.setProperty('--ui-glow-o', '0');
        el.style.setProperty('--ui-rotate-x', '0deg');
        el.style.setProperty('--ui-rotate-y', '0deg');
      });
    });
  }

  /* ── Brand proof — luminous cursor + touch response ───────── */
  function initBrandProofMotion(scope) {
    var racine = scope || document;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.ls-v5-proof-card', racine).forEach(function (card) {
      if (card.dataset.proofMotionReady === 'true') return;
      card.dataset.proofMotionReady = 'true';
      var clearTimer = null;
      var max = 4.2;

      function setPoint(clientX, clientY) {
        var r = card.getBoundingClientRect();
        var px = r.width ? (clientX - r.left) / r.width : 0.5;
        var py = r.height ? (clientY - r.top) / r.height : 0.5;
        px = Math.max(0, Math.min(1, px));
        py = Math.max(0, Math.min(1, py));
        card.style.setProperty('--proof-glare-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--proof-glare-y', (py * 100).toFixed(1) + '%');
        card.style.setProperty('--proof-glare-o', '1');
        if (!reduced) {
          var rx = (0.5 - py) * max * 2;
          var ry = (px - 0.5) * max * 2;
          card.style.transform = 'perspective(1050px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateZ(8px) scale(1.008)';
        }
      }

      function lightOn() {
        if (clearTimer) window.clearTimeout(clearTimer);
        card.classList.add('is-proof-lit');
        card.style.setProperty('--proof-glare-o', '1');
      }

      function lightOff(delay) {
        if (clearTimer) window.clearTimeout(clearTimer);
        clearTimer = window.setTimeout(function () {
          card.classList.remove('is-proof-lit');
          card.style.setProperty('--proof-glare-x', '50%');
          card.style.setProperty('--proof-glare-y', '50%');
          card.style.setProperty('--proof-glare-o', '0');
          if (!reduced) card.style.transform = 'perspective(1050px) rotateX(0deg) rotateY(0deg) translateZ(0) scale(1)';
        }, delay || 0);
      }

      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType === 'touch') return;
        lightOn();
      });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType === 'touch') return;
        lightOn();
        setPoint(e.clientX, e.clientY);
      });
      card.addEventListener('pointerleave', function (e) {
        if (e.pointerType && e.pointerType === 'touch') return;
        lightOff(0);
      });

      /* Touch has no true hover: illuminate at the finger position and let
         the glow linger briefly after release so the response is visible. */
      card.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') return;
        lightOn();
        setPoint(e.clientX, e.clientY);
      }, { passive:true });
      card.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'touch') return;
        lightOff(620);
      }, { passive:true });
      card.addEventListener('pointercancel', function (e) {
        if (e.pointerType !== 'touch') return;
        lightOff(220);
      }, { passive:true });

      card.addEventListener('focusin', lightOn);
      card.addEventListener('focusout', function () { lightOff(0); });
    });
  }

  /* ── Header glass — soft aqua light follows the cursor ────── */
  function initHeaderGlow(scope) {
    var racine = scope || document;
    var header = $('.lsv6-header', racine);
    if (!header || header.dataset.headerGlowReady === 'true') return;
    header.dataset.headerGlowReady = 'true';
    if (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    header.addEventListener('pointerenter', function () { header.style.setProperty('--header-glow-o', '.82'); });
    header.addEventListener('pointermove', function (e) {
      var r = header.getBoundingClientRect();
      var px = r.width ? (e.clientX - r.left) / r.width : 0.5;
      px = Math.max(0, Math.min(1, px));
      header.style.setProperty('--header-glow-x', (px * 100).toFixed(1) + '%');
    });
    header.addEventListener('pointerleave', function () {
      header.style.setProperty('--header-glow-x', '50%');
      header.style.setProperty('--header-glow-o', '0');
    });
  }

  function boot() { fixHomeLinks(); initQuiz(); initStickyCTA(); initProductCardMotion(document); initUniverseTilt(document); initLookTilt(document); initInteractiveGlow(document); initBrandProofMotion(document); initHeaderGlow(document); refreshCart(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
